// 19.1.3.1 Object.assign(target, source)
var $export = require('./_export');

$export($export.S + $export.F, 'Object', {assign: require('./_object-assign')});


//////////////////
// WEBPACK FOOTER
// /Users/fyrstenberg/Documents/Limbo/Roskilde-Handelsskole-Website-2023/frontend/~/core-js/modules/es6.object.assign.js
// module id = 236
// module chunks = 1